import * as API from "middleware/api";

const financesReadRequest = () => API.executeWithAccessToken("/finances.report.read");
export default financesReadRequest;
